import {Component, signal} from '@angular/core';
import {AvatarModule} from "primeng/avatar";
import {CustomTitle} from "lib-base";
import {DataViewModule} from "primeng/dataview";
import {DividerModule} from "primeng/divider";
import {Message, PrimeTemplate, TreeNode} from "primeng/api";
import {IGetNucleoFamiliar, IPerfilSisbenUsuario} from "../../../shared/interface/consultaSisben";
import {TranslateService} from "@ngx-translate/core";
import {DatasetDinamicoService} from "../../../services/dataset-dinamico.service";
import {ActivatedRoute, RouterLink} from "@angular/router";
import {TooltipModule} from "primeng/tooltip";
import {OrganizationChartModule} from "primeng/organizationchart";
import {NgClass} from "@angular/common";
import {ToastModule} from "primeng/toast";
import {MessagesModule} from "primeng/messages";
import {firstValueFrom} from "rxjs";

@Component({
  selector: 'app-detalle-sisben',
  standalone: true,
  imports: [
    AvatarModule, CustomTitle,
    DataViewModule, DividerModule,
    PrimeTemplate, RouterLink,
    TooltipModule,
    OrganizationChartModule, NgClass,
    ToastModule, MessagesModule
  ],
  templateUrl: './detalle-sisben.component.html',
  styles: `.puntaje {
    background-color: lightblue;
    color: white;
    padding: 1rem 2rem;
    border-radius: 10px;
    font-size: 4rem;
    max-width: 12rem;
    font-weight: bold;
  }

  ::ng-deep .p-organizationchart-node-content:has(.user-active) {
    background: linear-gradient(45deg, rgba(115, 171, 253, 0.25), transparent);
  }

  `
})
export class DetalleSisbenComponent {

  private jefeId?: number;
  usuario = signal<IPerfilSisbenUsuario | null>(null);
  private nucleoFamiliar: IGetNucleoFamiliar[] = [];
  orgChartData:TreeNode[] = [];
  messages: Message[] = [];
  loading = signal(false);
  puntaje = signal('');

  constructor(private _t: TranslateService,
              private datasetDinamicoService: DatasetDinamicoService,
              private activatedRoute: ActivatedRoute) {
  }

  ngOnInit(): void {
    this.activatedRoute.paramMap.subscribe(params => {
      this.jefeId = +params.get('jefe')!;
      Promise.all([this.getPuntajeSisben(), this.getPerfil(), this.getNucleoFamiliar()])
        .then((response) => {
            response[1] && this.usuario.set(response[1]);
            response[2] && (this.nucleoFamiliar = response[2]);
            this.generateTreeNode();
            response[0]  && this.puntaje.set(response[0].puntajeSisben);

        });
    });
    this.initMessages();
  }

  initMessages(): void {
    this.messages = [
      {severity: 'warn', detail: 'No se encontraron datos para la persona seleccionada.'},
    ]
  }

  //#region utils
  generateTreeNode(): void {
    if (this.nucleoFamiliar.length > 0) {
      const jefeHogar = this.nucleoFamiliar.find(member => member.jefeHogar);
      if (jefeHogar) {
        this.orgChartData = [
          {
            label: jefeHogar.nombreCompleto,
            data: jefeHogar,
            expanded:true,
            children: this.nucleoFamiliar
              .filter(member => !member.jefeHogar)
              .map(member => ({
                label: member.nombreCompleto,
                data: member
              }))
          }
        ];
      }
    }
  }
  //#endregion utils

  //#region call api
  private async getPerfil() {
    const id = this.jefeId;
    if (!id) return;
    this.loading.set(true);
   return await  firstValueFrom(this.datasetDinamicoService.getPerfilSisbenById(id))


  }

  private async getNucleoFamiliar() {
    const jefeFamiliaId = this.jefeId;
    if (!jefeFamiliaId) return;
    return await firstValueFrom(this.datasetDinamicoService.getNucleoFamiliarByJefeFamiliaId(jefeFamiliaId));
  }

  private async getPuntajeSisben() {
    const id = this.jefeId;
    if (!id) return;
    return await firstValueFrom(this.datasetDinamicoService.getPuntajeSisben(id))
  }


  //#endregion call api
}
